export enum TipoSolucion {
  INGRESO_PERMANENCIA_PROMOCION = 'INGRESO_PERMANENCIA_PROMOCION',
  DIASPORA = 'DIASPORA',
  EMERITOS = 'EMERITOS',
  AYUDANTES = 'AYUDANTES',
  BECAS_NACIONALES = 'BECAS_NACIONALES',
  BECAS_EXTRANJERAS = 'BECAS_EXTRANJERAS',
  POSGRADO_NACIONAL = 'POSGRADO_NACIONAL',
  POSDOCTORADO = 'POSDOCTORADO',
  CUENTAS_BANCARIAS = 'CUENTAS_BANCARIAS',
  ACREDITACIONES = 'ACREDITACIONES',
  ACREDITACIONES_SIN_INST = 'ACREDITACIONES_SIN_INST',
  INSTITUCIONES = 'INSTITUCIONES',
  REGISTRO_MATRICULA_SNP = 'REGISTRO_MATRICULA_SNP',
  ACREDITACIONES_PROGRAMAS = 'ACREDITACIONES_PROGRAMAS',
  REGISTRO_MATRICULA_LIC = 'REGISTRO_MATRICULA_LIC',
  APOYOS_COMPLEMENTARIOS_BN = 'APOYOS_COMPLEMENTARIOS_BN',
  APOYOS_COMPLEMENTARIOS_EXT = 'APOYOS_COMPLEMENTARIOS_EXT',
  ACREDITACION_MASIVA = 'ACREDITACION_MASIVA',
  MOVIMIENTOS_SITUACION = 'MOVIMIENTOS_SITUACION',
  EXCEPCIONES_SNII = 'EXCEPCIONES_SNII',
  EXCEPCIONES_EMERITOS_65 = 'EXCEPCIONES_EMERITOS_65',
  EXPEDIENTE_PERSONA = 'EXPEDIENTE_PERSONA',
  CUENTAS_BANCARIAS_SNII_INV = 'CUENTAS_BANCARIAS_SNII_INV',
  CUENTAS_BANCARIAS_SNII_AYU = 'CUENTAS_BANCARIAS_SNII_AYU',
  FORMATO_1_POSGRADO_NACIONAL = 'FORMATO_1_POSGRADO_NACIONAL',
  ACTIVIDAD_RETRIBUCION_SOCIAL = 'ACTIVIDAD_RETRIBUCION_SOCIAL',
}

/**
 * Función para convertir un string en un valor del enum.
 */
export default function asignarTipoSolucion(tsString: string): TipoSolucion | undefined {
  if (Object.values(TipoSolucion).includes(tsString as TipoSolucion)) {
    return tsString as TipoSolucion;
  }
  return null;
}
